import { render } from "./ThreadColorPicker.vue?vue&type=template&id=302bc276&scoped=true"
import script from "./ThreadColorPicker.vue?vue&type=script&lang=js"
export * from "./ThreadColorPicker.vue?vue&type=script&lang=js"

import "./ThreadColorPicker.vue?vue&type=style&index=0&id=302bc276&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302bc276"]])

export default __exports__